import allImgPaths from "assets/images";
import RadialBar from "components/common/charts/RadialBar";
import React, { useState } from "react";
import InsightCardsOptions from "./InsightCardsOptions";
import { Modal } from "components/common/modal/Modal";
import { HeaderModal } from "components/common/modal/Header";
import { Body } from "components/common/modal/Body";

const FeteCountDown = () => {
  const [showOptions, setShowOptions] = useState(false);
  const [openMaximizeModal, setOpenMaximizeModal] = useState(false);

  const MaximizeModal = () => {
    return (
      <Modal
        className={"modal-wrapper max-w-[690px] relative"}
        isShow={openMaximizeModal}
      >
        <img
          className='cursor-pointer absolute top-3 right-3'
          id='modal-toggle'
          src={allImgPaths.closeIcon}
          onClick={() => setOpenMaximizeModal(false)}
          alt='close icon'
        />
        <Body title='header' isShowBody={true} className=''>
          <div className='flex items-center rounded-xl w-full'>
            <RadialBar
              height="320"
              width="310"
            />
            <div className='origin-left scale-[1.2]'>
              <div className='flex items-center justify-between mb-5'>
                <div className='flex items-center gap-x-2'>
                  <h4 className='text-base font-interSemiBold text-[#101828]'>
                    Fete Countdown
                  </h4>
                  <div className=''>
                    <img
                      className='cursor-pointer'
                      src={allImgPaths.questionMarkIcon}
                      alt=''
                    />
                  </div>
                </div>
              </div>

              <p className='flex items-center gap-x-1 mb-2'>
                <span className='text-[#475467] font-interMedium text-sm'>
                  10:00 AM
                </span>
                -
                <span className='text-[#475467] font-interMedium text-sm'>
                  11:00 AM
                </span>
              </p>

              <p className='text-[#101828] text-2xl font-interSemiBold mb-2'>
                8 Jun 2024
              </p>

              <p className='text-sm font-interMedium text-[#D92D20]'>
                Urgent : Venue Selection
              </p>
            </div>
          </div>
        </Body>
      </Modal>
    );
  };

  return (
    <>
      <div className='flex items-center bg-[#fff] rounded-xl border border-[#EAECF0] pr-6 w-[calc(33%_-_12px)]'>
        <RadialBar />
        <div className='w-full'>
          {/* Heading */}
          <div className='flex items-center justify-between mb-5'>
            <div className='flex items-center gap-x-2'>
              <h4 className='text-base font-interSemiBold text-[#101828]'>
                Fete Countdown
              </h4>
              <div className=''>
                <img
                  className='cursor-pointer'
                  src={allImgPaths.questionMarkIcon}
                  alt=''
                />
              </div>
            </div>

            <div
              className='p-1 cursor-pointer relative hover:bg-[#f2f4f7] rounded w-5 focus-within:bg-[#f2f4f7]'
              onClick={() => setShowOptions(!showOptions)}
            >
              <img className="mx-auto" src={allImgPaths.threeVerticleDotsIcon} alt='three dots' />
              <InsightCardsOptions
                isShow={showOptions}
                openMaximizeModal={() => setOpenMaximizeModal(true)}
                chartName = 'radial_bar'
                downloadChartName = 'feteCountDown'
              />
            </div>
          </div>

          {/* Time */}
          <p className='flex items-center gap-x-1 mb-2'>
            <span className='text-[#475467] font-interMedium text-sm'>
              10:00 AM
            </span>
            -
            <span className='text-[#475467] font-interMedium text-sm'>
              11:00 AM
            </span>
          </p>

          {/* Date */}
          <p className='text-[#101828] text-2xl font-interSemiBold mb-2'>
            8 Jun 2024
          </p>

          {/* Venue */}
          <p className='text-sm font-interMedium text-[#D92D20]'>
            Urgent : Venue Selection
          </p>
        </div>
      </div>

      <MaximizeModal />
    </>
  );
};

export default FeteCountDown;
